import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";
import VueLazyload from "vue-lazyload";

import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
// import wechat, { oAuth, clearAuthStatus, auth, ready } from "@libs/wechat";
import { isWeixin, parseQuery, getUrlparam } from "@utils";

Vue.use(animate);
Vue.use(VueLazyload);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function(rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;

// router.beforeEach((to, from, next) => {
//   console.log(to.path);
//   // to and from are both route objects. must call `next`.
//   if (to.path == "/login") {
//     console.log(123);
//     // console.log(cookie.get(WX_AUTH))

//       if(!cookie.get(WX_AUTH)){
//         wechat();
//         clearAuthStatus();
//         oAuth();
//       }
//   }
//   next();
// });

const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}

var urlSpread = parseQuery()["spread"];

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}

const _isWechat = isWeixin();

// const module = () => import("vconsole");
// module().then(Module => {
//   new Module.default();
// });


// 从其他地方跳转过来 type=1 获取信息 自动登录
  const _isparams = getUrlparam();
// if (location.host == 'gzh.xiaojiangwh.com' || location.host == '192.168.31.157:8082') {
  if (location.host == 'new-gzh.xiaojiangwh.com') {
  if (_isparams && _isparams.token && _isparams.outerType == 1) {
    // const expires_time = new Date(JSON.stringify(_isparams.expires_time).replace(/-/g, "/")).getTime();
    // console.log(expires_time, "time");
    const datas = {
      token: _isparams.token,
      // expires_time: expires_time
    };
    store.commit("LOGIN", datas.token);
    cookie.set("temporary_login_status", datas.token);
    cookie.set("hide_other", true);
  }
}
//

//
if (location.href.indexOf('/loginphone') !== -1) {
  if (cookie.get("temporary_login_status")) {
    if (cookie.get("loginphone")) {
      // cookie.remove("loginphone");
    }
  } else {
    if (!cookie.get("loginphone")) {
      cookie.set("loginphone", true);
    }
  }
}

if (_isWechat) {
  if (_isparams && _isparams.outerType == 1) {
      // console.log("不授权");
  } else if ( cookie.get("loginphone") ) {
      // console.log("不授权");
  } else {
    const module = () => import("@libs/wechat");
    module().then(Module => {
      Module.default().then(() => Module.oAuth());
    });
  }
}

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
